import React, { useState } from 'react';
import { donationsService } from '../services/api';
import './DonationForm.css';

const DonationForm = ({ donor_id, initialData = null, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState(initialData ? {
    ...initialData,
    donation_date: (initialData?.donation_date ?? new Date().toISOString()).split('T')[0]
  } : {
    donor_id: donor_id,
    amount: '',
    donation_date: new Date().toISOString().split('T')[0],
    donation_type: 'cash',
    notes: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    })); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.amount || formData.amount <= 0) {
      setError('Amount must be greater than 0');
      return;
    }

    if (!formData.donation_date) {
      setError('Donation date is required');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      if (initialData?.id) {
        await donationsService.update(initialData.id, formData);
      } else {
        await donationsService.create(formData);
      }
      
      if (onSubmit) onSubmit();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save donation');
      console.error('Error saving donation:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="form-header">
          <h3>{initialData ? 'Edit Donation' : 'Record New Donation'}</h3>
          <button 
            className="close-btn"
            onClick={onCancel}
            disabled={loading}
          >
            ✕
          </button>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="form">
          <div className="form-group">
            <label htmlFor="amount">Amount *</label>
            <input
              type="number"
              id="amount"
              name="amount"
              step="0.01"
              min="0"
              value={formData.amount}
              onChange={handleChange}
              placeholder="0.00"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="donation_date">Date *</label>
            <input
              type="date"
              id="donation_date"
              name="donation_date"
              value={formData.donation_date}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="donation_type">Type</label>
            <select
              id="donation_type"
              name="donation_type"
              value={formData.donation_type}
              onChange={handleChange}
              disabled={loading}
            >
              <option value="cash">Cash</option>
              <option value="check">Check</option>
              <option value="credit_card">Credit Card</option>
              <option value="bank_transfer">Bank Transfer</option>
              <option value="online">Online</option>
              <option value="stock">Stock</option>
              <option value="property">Property</option>
              <option value="in_kind">In-Kind</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="notes">Notes</label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Any notes about this donation..."
              rows="3"
              disabled={loading}
            />
          </div>

          <div className="form-actions">
            <button 
              type="button"
              className="btn btn-outline"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Saving...' : (initialData ? 'Update' : 'Record')} Donation
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DonationForm;
